import Box, { type BoxProps } from "@mui/material/Box";
import type React from "react";
import * as VerticalPageLayoutComponents from "./VerticalPageLayout.components";
import { styled } from "@mui/material";

interface VerticalPageLayoutProps {
  top: React.ReactNode;
  warning?: React.ReactNode;
  title?: React.ReactNode;
  main: React.ReactNode;
  slotProps?: {
    root?: BoxProps;
  };
}

const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(2),
  height: "100%",
}));

/**
 * @deprecated
 */
function VerticalPageLayout(props: VerticalPageLayoutProps) {
  return (
    <>
      {props.warning}
      <Root {...props.slotProps?.root}>
        <Box>{props.top}</Box>
        {Boolean(props.title) && <Box>{props.title}</Box>}
        <VerticalPageLayoutComponents.NoMinHeightStyledBox display="flex" flex={1} position="relative">
          {props.main}
        </VerticalPageLayoutComponents.NoMinHeightStyledBox>
      </Root>
    </>
  );
}
export default VerticalPageLayout;
